import { Component, AfterViewInit } from '@angular/core';
import { OidcService } from './oidc.service';
import { Log } from 'ng2-logger';

const log = Log.create("OidcSilentAuthenticateComponent");

@Component({
  moduleId: module.id,
  selector: 'oidc-silent-authenticate',
  template: '<p>Logging in...</p>',
})
export class OidcSilentAuthenticateComponent implements AfterViewInit {

  constructor(
    private oidcService: OidcService,
  ) {}

  ngAfterViewInit() {
    log.info("Handling authentication...");

    // oidc-client-ts does NOT like our #, so we get rid of it before parsing
    let newLocation = window.location.href.split("#")[1];
    window.history.replaceState({}, null, newLocation);
    
    // For the silent authentication we don't need to do much since the user loaded
    // event will handle everything for us
    this.oidcService.signinSilentCallback().subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/oidc_silent_authenticate.component.ts